import { LanguagesSelectService } from './languages.selector';
import { SettingSelectService } from './setting.selector';

export { LanguagesSelectService, SettingSelectService };

export const list = [LanguagesSelectService, SettingSelectService];
